import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_25dab543 from 'nuxt_plugin_plugin_25dab543' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_2e1b4d8b from 'nuxt_plugin_plugin_2e1b4d8b' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_toastplugin8fffd702_b7cdd7d0 from 'nuxt_plugin_toastplugin8fffd702_b7cdd7d0' // Source: ./toast.plugin.8fffd702.js (mode: 'all')
import nuxt_plugin_editorpluginf13cf0c2_63981c31 from 'nuxt_plugin_editorpluginf13cf0c2_63981c31' // Source: ./editor.plugin.f13cf0c2.js (mode: 'all')
import nuxt_plugin_radiobuttonplugin596e2385_290d5fc4 from 'nuxt_plugin_radiobuttonplugin596e2385_290d5fc4' // Source: ./radiobutton.plugin.596e2385.js (mode: 'all')
import nuxt_plugin_messageplugin0d4adcc2_1e071b6c from 'nuxt_plugin_messageplugin0d4adcc2_1e071b6c' // Source: ./message.plugin.0d4adcc2.js (mode: 'all')
import nuxt_plugin_textareaplugin2c7a7dec_4ca5121c from 'nuxt_plugin_textareaplugin2c7a7dec_4ca5121c' // Source: ./textarea.plugin.2c7a7dec.js (mode: 'all')
import nuxt_plugin_dialogplugin7e3e8dba_41d5e79f from 'nuxt_plugin_dialogplugin7e3e8dba_41d5e79f' // Source: ./dialog.plugin.7e3e8dba.js (mode: 'all')
import nuxt_plugin_passwordplugin53df07e6_66ce2702 from 'nuxt_plugin_passwordplugin53df07e6_66ce2702' // Source: ./password.plugin.53df07e6.js (mode: 'all')
import nuxt_plugin_checkboxplugin194ee996_80f996f6 from 'nuxt_plugin_checkboxplugin194ee996_80f996f6' // Source: ./checkbox.plugin.194ee996.js (mode: 'all')
import nuxt_plugin_buttonplugin3b32db24_43f5a3b2 from 'nuxt_plugin_buttonplugin3b32db24_43f5a3b2' // Source: ./button.plugin.3b32db24.js (mode: 'all')
import nuxt_plugin_multiselectpluginb7cefbe6_614b4b89 from 'nuxt_plugin_multiselectpluginb7cefbe6_614b4b89' // Source: ./multiselect.plugin.b7cefbe6.js (mode: 'all')
import nuxt_plugin_dropdownplugincacdabfa_a626cb34 from 'nuxt_plugin_dropdownplugincacdabfa_a626cb34' // Source: ./dropdown.plugin.cacdabfa.js (mode: 'all')
import nuxt_plugin_columnplugin5c5cab70_f3aa4ab4 from 'nuxt_plugin_columnplugin5c5cab70_f3aa4ab4' // Source: ./column.plugin.5c5cab70.js (mode: 'all')
import nuxt_plugin_datatableplugind252ba08_4311c628 from 'nuxt_plugin_datatableplugind252ba08_4311c628' // Source: ./datatable.plugin.d252ba08.js (mode: 'all')
import nuxt_plugin_inputtextplugincfebae62_2a43f00b from 'nuxt_plugin_inputtextplugincfebae62_2a43f00b' // Source: ./inputtext.plugin.cfebae62.js (mode: 'all')
import nuxt_plugin_configplugin6ad86334_203e645a from 'nuxt_plugin_configplugin6ad86334_203e645a' // Source: ./config.plugin.6ad86334.js (mode: 'all')
import nuxt_plugin_axios_1b886cd9 from 'nuxt_plugin_axios_1b886cd9' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_amplifyconfig_4d66aab6 from 'nuxt_plugin_amplifyconfig_4d66aab6' // Source: ../plugins/amplify-config.js (mode: 'all')
import nuxt_plugin_amplifycomponents_3b5021e2 from 'nuxt_plugin_amplifycomponents_3b5021e2' // Source: ../plugins/amplify-components.js (mode: 'all')
import nuxt_plugin_axios_673c6d87 from 'nuxt_plugin_axios_673c6d87' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_appui_4329c131 from 'nuxt_plugin_appui_4329c131' // Source: ../plugins/app-ui.js (mode: 'all')
import nuxt_plugin_filter_13ed0f0e from 'nuxt_plugin_filter_13ed0f0e' // Source: ../plugins/filter.js (mode: 'all')
import nuxt_plugin_vuexpersist_13f465a2 from 'nuxt_plugin_vuexpersist_13f465a2' // Source: ../plugins/vuex-persist (mode: 'client')
import nuxt_plugin_eventbus_2faefc80 from 'nuxt_plugin_eventbus_2faefc80' // Source: ../plugins/event-bus.js (mode: 'all')
import nuxt_plugin_appservices_65c090f7 from 'nuxt_plugin_appservices_65c090f7' // Source: ../plugins/app-services.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Service Counter","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_25dab543 === 'function') {
    await nuxt_plugin_plugin_25dab543(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_2e1b4d8b === 'function') {
    await nuxt_plugin_plugin_2e1b4d8b(app.context, inject)
  }

  if (typeof nuxt_plugin_toastplugin8fffd702_b7cdd7d0 === 'function') {
    await nuxt_plugin_toastplugin8fffd702_b7cdd7d0(app.context, inject)
  }

  if (typeof nuxt_plugin_editorpluginf13cf0c2_63981c31 === 'function') {
    await nuxt_plugin_editorpluginf13cf0c2_63981c31(app.context, inject)
  }

  if (typeof nuxt_plugin_radiobuttonplugin596e2385_290d5fc4 === 'function') {
    await nuxt_plugin_radiobuttonplugin596e2385_290d5fc4(app.context, inject)
  }

  if (typeof nuxt_plugin_messageplugin0d4adcc2_1e071b6c === 'function') {
    await nuxt_plugin_messageplugin0d4adcc2_1e071b6c(app.context, inject)
  }

  if (typeof nuxt_plugin_textareaplugin2c7a7dec_4ca5121c === 'function') {
    await nuxt_plugin_textareaplugin2c7a7dec_4ca5121c(app.context, inject)
  }

  if (typeof nuxt_plugin_dialogplugin7e3e8dba_41d5e79f === 'function') {
    await nuxt_plugin_dialogplugin7e3e8dba_41d5e79f(app.context, inject)
  }

  if (typeof nuxt_plugin_passwordplugin53df07e6_66ce2702 === 'function') {
    await nuxt_plugin_passwordplugin53df07e6_66ce2702(app.context, inject)
  }

  if (typeof nuxt_plugin_checkboxplugin194ee996_80f996f6 === 'function') {
    await nuxt_plugin_checkboxplugin194ee996_80f996f6(app.context, inject)
  }

  if (typeof nuxt_plugin_buttonplugin3b32db24_43f5a3b2 === 'function') {
    await nuxt_plugin_buttonplugin3b32db24_43f5a3b2(app.context, inject)
  }

  if (typeof nuxt_plugin_multiselectpluginb7cefbe6_614b4b89 === 'function') {
    await nuxt_plugin_multiselectpluginb7cefbe6_614b4b89(app.context, inject)
  }

  if (typeof nuxt_plugin_dropdownplugincacdabfa_a626cb34 === 'function') {
    await nuxt_plugin_dropdownplugincacdabfa_a626cb34(app.context, inject)
  }

  if (typeof nuxt_plugin_columnplugin5c5cab70_f3aa4ab4 === 'function') {
    await nuxt_plugin_columnplugin5c5cab70_f3aa4ab4(app.context, inject)
  }

  if (typeof nuxt_plugin_datatableplugind252ba08_4311c628 === 'function') {
    await nuxt_plugin_datatableplugind252ba08_4311c628(app.context, inject)
  }

  if (typeof nuxt_plugin_inputtextplugincfebae62_2a43f00b === 'function') {
    await nuxt_plugin_inputtextplugincfebae62_2a43f00b(app.context, inject)
  }

  if (typeof nuxt_plugin_configplugin6ad86334_203e645a === 'function') {
    await nuxt_plugin_configplugin6ad86334_203e645a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_1b886cd9 === 'function') {
    await nuxt_plugin_axios_1b886cd9(app.context, inject)
  }

  if (typeof nuxt_plugin_amplifyconfig_4d66aab6 === 'function') {
    await nuxt_plugin_amplifyconfig_4d66aab6(app.context, inject)
  }

  if (typeof nuxt_plugin_amplifycomponents_3b5021e2 === 'function') {
    await nuxt_plugin_amplifycomponents_3b5021e2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_673c6d87 === 'function') {
    await nuxt_plugin_axios_673c6d87(app.context, inject)
  }

  if (typeof nuxt_plugin_appui_4329c131 === 'function') {
    await nuxt_plugin_appui_4329c131(app.context, inject)
  }

  if (typeof nuxt_plugin_filter_13ed0f0e === 'function') {
    await nuxt_plugin_filter_13ed0f0e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_13f465a2 === 'function') {
    await nuxt_plugin_vuexpersist_13f465a2(app.context, inject)
  }

  if (typeof nuxt_plugin_eventbus_2faefc80 === 'function') {
    await nuxt_plugin_eventbus_2faefc80(app.context, inject)
  }

  if (typeof nuxt_plugin_appservices_65c090f7 === 'function') {
    await nuxt_plugin_appservices_65c090f7(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
